import { Box, BoxProps } from '@chakra-ui/react'
import React from 'react'
export interface CustomScrollbarProps extends BoxProps {
  hasBorder?: boolean
}

export const CustomScrollbar: React.FC<CustomScrollbarProps> = React.forwardRef<
  HTMLDivElement,
  CustomScrollbarProps
>(({ hasBorder, ...props }, ref) => {
  const sxCustomScrollbar = {
    '&::-webkit-scrollbar': {
      boxShadow: hasBorder ? '-1px 0 0 0 #e8e8e8' : undefined,
      width: '14px',
    },

    '&::-webkit-scrollbar-thumb': {
      '&:hover': {
        boxShadow: 'inset 0 0 0 20px #d9d9d9',
      },
      border: '4px transparent solid',
      borderRadius: '30px',
      boxShadow: 'inset 0 0 0 20px #c8c8c8',

      transition: 'all 0.2s ease-in',
    },
  }
  return <Box ref={ref} sx={{ sxCustomScrollbar }} {...props} />
})
CustomScrollbar.displayName = 'CustomScrollbar'
